import { useEffect, useState } from 'react';
import { header } from '../../portfolio';
import Navbar from '../Navbar/Navbar';
import './Header.css';

const Header = () => {
  const { homepage, title } = header;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header center ${scrolled ? 'header--scrolled' : ''}`}>
      <h3>
        {homepage ? (
          <a href={homepage} className='link header__logo'>
            {title}
          </a>
        ) : (
          <span className='header__logo'>{title}</span>
        )}
      </h3>
      <Navbar />
    </header>
  );
};

export default Header;
